// internal imports
import IService from 'core/service/IService';
import Class from 'core/util/Class';
import Logger from 'core/util/Logger';
import { IMutationResult } from '../mutation/IMutationService';

export default abstract class IConfigService implements IService {
	protected static DEFAULT_ID = "default";
	private static REGISTRY: string = "config";

	public getRegistry(): string {
		return IConfigService.REGISTRY;
	}

	public getActive(): string {
		return IConfigService.DEFAULT_ID;
	}

	public getConditions = () => undefined;

	public abstract getConfig(key?: string): Promise<object>;

	public abstract getContextProperties(key?: string): Promise<object>;

	public abstract saveConfig(config: object, key?: string): Promise<IMutationResult<object>>;

	public abstract getLayout(): Promise<object>;

	public abstract getServiceId(): string;
}



// WEBPACK FOOTER //
// ./src/core/service/config/IConfigService.ts